import { useContext } from 'react'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { createDeferredPromise } from '../../../../utils/async'
import { EmailFormContext } from '../../EmailForm.context'
import { EmailGoogleTemplateModal } from '../../EmailGoogleTemplateModal'
import {
  getEmailFormNextDocTemplates,
  getEmailFormRemainingDocTemplates,
} from '../EmailCreationForm.utils'

export function useGoogleTemplate({
  docTemplateCheckRef,
  setDocTemplates,
  templateEntityApiParams,
  templateFolder,
}) {
  const { setModal, onCloseModal } = useContext(EmailFormContext)

  function handleOpenGoogleTemplate({
    editedTemplate = null,
    onClose = onCloseModal,
  } = EMPTY_OBJECT) {
    async function handleAddTemplate(template) {
      const { promise, resolve } = createDeferredPromise()

      docTemplateCheckRef.current = resolve

      setDocTemplates(docTemplates =>
        getEmailFormNextDocTemplates({ docTemplates, editedTemplate, template })
      )

      return promise
    }

    setModal(
      <EmailGoogleTemplateModal
        docTemplate={editedTemplate}
        folder={templateFolder}
        templateEntityApiParams={templateEntityApiParams}
        onAddTemplate={handleAddTemplate}
        onClose={onClose}
      />
    )
  }

  function handleDeleteGoogleTemplate(removedTemplate) {
    setDocTemplates(docTemplates =>
      getEmailFormRemainingDocTemplates({ docTemplates, removedTemplate })
    )
  }

  return {
    handleDeleteGoogleTemplate,
    handleOpenGoogleTemplate,
  }
}
